<div class="settings">
    @if (showPlaylistTabs()) {
        <app-add-content-tabs
            [tabs]="tabs"
            [currentTab]="currentTab()"
            (tabClick)="onTabClick($event)" />
    }

    <div class="settings__tab-content mt-5">
        @switch (currentTab()) {
            @case (0) {
                <div>
                    <ntv-input
                        #inputRef
                        type="number"
                        [formControl]="contentDurationFC"
                        [showError]="true"
                        [minValue]="5"
                        [maxValue]="3600"
                        placeholder="20"
                        [error]="getErrorMessage()"
                        label="Duration, default is 20. (Applies to non-video assets)"
                        (keydown)="onKeydown($event)"
                        (focus)="contentDurationFC.markAsTouched()"
                        (blur)="onBlur()">
                        @if (
                            !contentDurationFC.value || contentDurationFC.value.toString() === ''
                        ) {
                            <p hint class="text-xs text-info-main mt-1 italic">
                                If left blank, this will default to 20.
                            </p>
                        }
                    </ntv-input>
                </div>

                @if (showForTM()) {
                    <p class="text-description mt-2">
                        These assets will be set to fullscreen by default
                    </p>
                } @else {
                    <div class="settings__set-fullscreen mt-4 flex items-center justify-between">
                        <span class="text-sm-primary--bold">Set to Fullscreen</span>
                        <ntv-toggle-button
                            [(checked)]="setFullscreen"
                            (checkedChange)="emitChanges()" />
                    </div>
                }
            }
            @case (1) {
                <div class="settings__play-where flex items-center justify-between">
                    <div>
                        <h4 class="text-base--primary">Whitelist Hosts and Licenses</h4>
                        <p class="text-description">
                            Select host and licenses you want this content to play or toggle all.
                        </p>
                    </div>
                    <ntv-toggle-button />
                </div>
            }
            @case (2) {
                <app-tabs [tabs]="subTabs" [(selectedTabIndex)]="currentSubTab" />
                <div class="mt-5">
                    @switch (currentSubTab()) {
                        @case (0) {
                            <div class="grid place-items-center bg-gray-100 p-10 rounded-md">
                                <svg width="40" height="40">
                                    <use xlink:href="assets/icons/icons-sprite.svg#clock"></use>
                                </svg>
                                <h4 class="text-base--primary mt-2">Default Play</h4>
                                <p class="text-description">
                                    This content will play during business hours
                                </p>
                            </div>
                        }
                        @case (1) {
                            <div class="flex flex-col gap-4">
                                <div class="flex flex-col gap-2">
                                    <h4 class="text-base--primary">Date Range</h4>
                                    <ntv-date-range-picker
                                        variant="double"
                                        (dates)="onDatesChange($event)" />
                                </div>

                                <div class="flex items-center justify-between control-group mt-4">
                                    <div class="flex flex-col gap-2">
                                        <p class="text-base--primary">Play Time</p>
                                        <div class="flex gap-4">
                                            <div>
                                                <label
                                                    class="font-semibold text-custom-media-label text-sm"
                                                    >Start Time</label
                                                >
                                                <div class="border rounded-md px-2 mt-1">
                                                    <ntv-timepicker
                                                        format="12h"
                                                        [formControl]="playTimeStartFC"
                                                        [error]="
                                                            getTimeErrorMessage(playTimeStartFC)
                                                        "
                                                        (focus)="playTimeStartFC.markAsTouched()" />
                                                </div>
                                            </div>
                                            <div>
                                                <label
                                                    class="font-semibold text-custom-media-label text-sm"
                                                    >End Time</label
                                                >
                                                <div class="border rounded-md px-2 mt-1">
                                                    <ntv-timepicker
                                                        format="12h"
                                                        [formControl]="playTimeEndFC"
                                                        [error]="getTimeErrorMessage(playTimeEndFC)"
                                                        (focus)="playTimeEndFC.markAsTouched()" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex items-center gap-4">
                                        <ntv-toggle-button
                                            [(checked)]="is24Hours"
                                            (checkedChange)="emitChanges()" />
                                        <label class="font-bold">24 Hours Play</label>
                                    </div>
                                </div>

                                <div
                                    class="flex items-center justify-between control-group mt-4 border-t border-b py-4">
                                    <p class="text-base--primary">Alternate Weeks</p>
                                    <div class="flex items-center gap-2">
                                        <ntv-toggle-button />
                                        <label class="font-bold">Every other (0) week</label>
                                    </div>
                                </div>

                                <div class="flex items-center justify-between control-group mt-2">
                                    <div class="">
                                        <p class="text-base--primary">Select Days</p>
                                        <div class="mt-2 flex items-center gap-5">
                                            @for (day of WEEK_DAYS; track day) {
                                                <div class="flex items-center gap-3">
                                                    <ntv-checkbox
                                                        [checked]="selectedDays().includes(day)"
                                                        (checkedChange)="toggleDay(day)"
                                                        size="md" />
                                                    <label>{{ day }}</label>
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div class="flex items-center gap-2">
                                        <ntv-toggle-button
                                            [checked]="playAllDays()"
                                            (checkedChange)="togglePlayAllDays($event)" />
                                        <label class="font-bold">Play on all days</label>
                                    </div>
                                </div>
                            </div>
                        }
                        @case (2) {
                            <div class="grid place-items-center bg-gray-100 p-10 rounded-md">
                                <svg width="40" height="40">
                                    <use xlink:href="assets/icons/icons-sprite.svg#clock"></use>
                                </svg>
                                <h4 class="text-base--primary mt-2">Do Not Play</h4>
                                <p class="text-description">This content will not play at all</p>
                            </div>
                        }
                    }
                </div>
            }
        }
    </div>
</div>
